import { render } from "./index.vue?vue&type=template&id=3071560a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3071560a&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=3071560a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3071560a"]])

export default __exports__